//
//
//
//
//
//
//
//
//
//
export default {
  name: 'CorePasswordField',
  inheritAttrs: false,
  props: {
    showPassword: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      commonAttrs: {
        outlined: true,
        filled: false
      },
      isContentHidden: !this.showPassword
    };
  }
};